import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { ConsigneesActions } from '../StoreAdapter'
import { ConsigneeSchema } from '../../../Schema/ConsigneeSchema'
import { ServiceLocator } from '../../../Services/ServiceLocator'
import { ConsigneesAPI } from '../../../Services/API/ConsigneesAPI'

export const useUpdateConsignee = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [errors, setErrors] = useState<
    Record<string, string> | Record<string, string>[]
  >(null)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const updateConsignee = useCallback(
    async (schema: ConsigneeSchema): Promise<ConsigneeSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(ConsigneesAPI)
        .updateEntity(schema)
        .then((schema) => {
          dispatch(ConsigneesActions.updateOne(schema))
          if (mounted.current) {
            setProcessing(false)
            setErrors(null)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setErrorMessage(err?.response?.data?.errorMessage)
            setErrors(err?.response?.data?.errors)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    errors,
    errorMessage,
    updateConsignee,
  }
}
